import { render } from "./chooseGame.vue?vue&type=template&id=66961297"
import script from "./chooseGame.vue?vue&type=script&lang=js"
export * from "./chooseGame.vue?vue&type=script&lang=js"
script.render = render

export default script